import React, { useCallback, useMemo } from 'react';

import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import Filters from 'components/Filters';
import InputWithDebouncedAction from 'components/InputWithDebouncedAction/InputWithDebouncedAction';
import processing_activities_messages from 'messages/processing_activities_messages';

import {
  buildProcessingActivitiesTableAvailableFilters,
  mergeTableFiltersIntoFilterValues,
  processingActivitiesFilterValuesToTableFilters,
  type ProcessingActivitiesFilterValues,
  type ProcessingActivitiesTableFilterState,
} from '../processingActivitiesFilters';
import useStyles from '../ProcessingActivitiesPage.styles';

type Props = {
  filters: ProcessingActivitiesFilterValues;
  onFiltersChange: (filters: ProcessingActivitiesFilterValues) => void;
  onSearch: (value: string) => void;
  searchValue: string;
};

const ProcessingActivitiesToolbar: React.FC<Props> = ({ filters, onFiltersChange, onSearch, searchValue }) => {
  const { t } = useTranslation();
  const styles = useStyles();

  const availableTableFilters = useMemo(() => buildProcessingActivitiesTableAvailableFilters(), []);

  const tableFilters = useMemo(() => processingActivitiesFilterValuesToTableFilters(filters), [filters]);

  const setTableFilters = useCallback(
    (updater: React.SetStateAction<ProcessingActivitiesTableFilterState>) => {
      const currentTableFilters = processingActivitiesFilterValuesToTableFilters(filters);
      const nextTableFilters = typeof updater === 'function' ? updater(currentTableFilters) : updater;
      onFiltersChange(mergeTableFiltersIntoFilterValues(filters, nextTableFilters));
    },
    [filters, onFiltersChange],
  );

  return (
    <Box className={styles.toolbarSection}>
      <Box className={styles.searchRow}>
        <div className={styles.searchInputCell}>
          <InputWithDebouncedAction
            action={onSearch}
            formControl={{ size: 'small' }}
            label={t(processing_activities_messages.filters.search_placeholder)}
            value={searchValue}
          />
        </div>
        <Filters availableFilters={availableTableFilters} filters={tableFilters} setFilters={setTableFilters} />
      </Box>
    </Box>
  );
};

export default ProcessingActivitiesToolbar;
